import { __ } from '@wordpress/i18n';
import { ToolbarGroup, ToolbarButton } from '@wordpress/components';
import { BlockControls } from '@wordpress/block-editor';
import { useDispatch, useSelect } from '@wordpress/data';
import { createBlock } from '@wordpress/blocks';
import { CopyPasteStyles } from '@vayu-blocks';

export const CustomBlockControls = ({ setAttributes, attributes, clientId }) => {
	const { insertBlock } = useDispatch('core/block-editor');

	// Get innerBlocks clientId (for InnerBlocks container)
	const innerBlockClientId = useSelect((select) => {
		const { getBlockOrder } = select('core/block-editor');
		return getBlockOrder(clientId)[0]; // First position for InnerBlocks inside parent
	}, [clientId]);

	const addFAQItem = () => {
		const newBlock = createBlock('vayu-blocks/faq-child', {});
		insertBlock(newBlock, undefined, clientId); // Insert directly into parent InnerBlocks
	};

	return (
		<BlockControls>
			<ToolbarGroup>
				<ToolbarButton
					icon="plus"
					label={__('Add FAQ Item', 'vayu-blocks')}
					onClick={addFAQItem}
				/>
				<CopyPasteStyles
					attributes={attributes}
					setAttributes={setAttributes}
					blockName={'vayu-blocks/faq'}
				/>
			</ToolbarGroup>
		</BlockControls>
	);
};
